import { _axios } from '@/plugins/axios';

const apiResource = 'api/v1/standards-api';

export default {
  /**
   * Check if IEC requirements table is empty
   */
  checkRequirementsStatus: () => _axios.get(`${apiResource}/requirements/status`),

  /**
   * Sync IEC requirements from Standard API to database
   * Clears existing requirements and imports fresh ones
   */
  syncRequirements: () => _axios.post(`${apiResource}/requirements/sync`),

  /**
   * Clear all IEC requirements from database
   * Typically used before syncing fresh data
   */
  clearRequirements: () => _axios.delete(`${apiResource}/requirements/clear`),

  /**
   * Sync requirements with error handling
   * Returns { status, message, count, deletedCount }
   */
  syncRequirementsWithStatus: () => _axios.post(`${apiResource}/requirements/sync`),
};
